<script>

import NoResults from '@/launcher/components/shared/NoResults.vue';
import LoadingRing from '@/launcher/components/shared/LoadingRing.vue';
import GamesGrid from '../shared/GamesGrid';
import { Slider } from 'vue-sliderx';

export default {
  name: 'GamesFilteredBox',
  props: {
    filteredGames: {
      required: true,
    },
    loading: {},
  },
  components: {
    GamesGrid,
    NoResults,
    LoadingRing,
    Slider,
  },
  computed: {
    gridToDisplay () {
      return Math.trunc(this.filteredGames.length / 16) + 1;// 4 x 4 grid
    },
  },
};
</script>

<template lang="pug">
div.games-filtered-box.bg-black-overlay.h-100._collision.relative
  .pt4.tc(v-if="loading || filteredGames.length === 0")
    loading-ring.loading.center.mt4(v-if="loading")
    no-results.noresults.animated.fadeIn(v-else-if="filteredGames.length === 0")
      span {{ $t('Select different filters or') }} #[link-style: button.clearbtn(@click="$emit('clear-filters')") {{ $t('clear them all') }}]
  slider.slider.flex.flex-column.h-100(:per-page="1", v-else, :clone="false", :loop="false")
    arrow-button.prevbtn.center.db.absolute.top-0.left-50.z-1(small, slot="prev", slot-scope="{ canPrev, prev, index }", @click="prev", :style="{visibility: canPrev && index > 0 ? 'visible': 'hidden'}")
    GamesGrid.gamegrid(:games="filteredGames.slice((i - 1) * 16, i * 16)", v-for="i in gridToDisplay", :key="i")
    arrow-button.nextbtn.center.db.absolute.bottom-0.left-50.z-1.translate-x--50(small, slot="next", slot-scope="{ canNext, next }", @click="next", :style="{visibility: canNext && gridToDisplay >= 1 ? 'visible': 'hidden'}")

</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.games-filtered-box {
}
</style>
<style>
.games-filtered-box {
  & .slider {
    & .prevbtn {
      transform: rotate(180deg) translateX(50%);
    }
     & .gamegrid {
      padding: 4rem;
      margin-top: 0.5rem;
    }
  }
}
</style>
